import React from "react";
import PolymatchResults from "./PolymatchResults";

const PolymatchResults_Coding = () => {
  // Pass Coding competition data to the results page
  return <PolymatchResults 
    competition="coding" 
    competitionHeading="Coding Competition"
    year="2025"
  />;
};

export default PolymatchResults_Coding;
